import api from '../api';
export const PROCUREMENT_FEATURES = ['lots', 'suppliers', 'lot_analytics', 'supplier_analytics', 'possible_suppliers', 'search_alerts'] as const;
export type ProcurementFeature = typeof PROCUREMENT_FEATURES[number];
export interface ProcurementTrial {
  status: 'available' | 'active' | 'expired' | 'unavailable';
  started_at: string | null;
  expires_at: string | null;
  duration_days: number;
}
export interface ProcurementAccess {
  trial?: ProcurementTrial;
  features: Record<ProcurementFeature, boolean>;
  max_active_searches: number | null;
  channels: ('site' | 'telegram')[];
  is_admin: boolean;
  telegram_linked: boolean;
  sources: { kind: 'subscription' | 'manual' | 'admin' | 'trial'; id: string; expires_at: string | null }[];
  next_change_at: string | null;
  settings: { lots_enabled: boolean; suppliers_enabled: boolean; search_alerts_enabled: boolean; check_interval_minutes: number; max_stored_searches_per_user?: number };
}
export const getProcurementAccess = async (signal?: AbortSignal): Promise<ProcurementAccess> =>
  (await api.get('/procurement/access', { signal })).data;

export const startProcurementTrial = async (): Promise<ProcurementAccess> =>
  (await api.post('/procurement/trial')).data;
